@if(value === 0.0) {
<div class="flex items-center rounded-lg px-1.5">
  <i class="pi pi-equals justify-self-center"></i>
</div>
} @else if(value <= -200.0) {
<div class="flex items-center rounded-lg px-1.5">
  <i class="pi pi-blank justify-self-center"></i>
</div>
} @else {
<div class="flex items-center gap-x-1 rounded-lg px-1.5" [ngClass]="getColor()">
  <i [ngClass]="getIcon()"></i>
  <span class="text-value">{{ value | percent }}</span>
</div>
}
